import React from "react"
import { withTranslation, WithTranslation } from "react-i18next"
import { observer, inject } from "mobx-react"
import Store from "../stores/Store"
import Grid from "@material-ui/core/Grid"
import TextField from "@material-ui/core/TextField"
import Autocomplete from "@material-ui/lab/Autocomplete"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import Checkbox from "@material-ui/core/Checkbox"
import { countries, CountryType } from "../records/Countries"

interface HolderFormProps extends WithTranslation {
    store?: Store
}

interface HolderFormState {
    nameError: boolean;
    surnameError: boolean;
    emailError: boolean;
}

@inject("store")
@observer
class HolderForm extends React.Component<HolderFormProps, HolderFormState> {
    constructor (props: HolderFormProps) {
        super(props)

        this.state = {
            nameError: false,
            surnameError: false,
            emailError: false
        }
    }

    setName = (event: any) => {
        const name: string = event.target.value

        if (name.length > 1) {
            this.props.store!.setHolderData({
                name: name
            })
            this.setState({
                nameError: false
            })
        } else {
            this.setState({
                nameError: true
            })
        }
    }

    setSurname = (event: any) => {
        const surname: string = event.target.value

        if (surname.length > 1) {
            this.props.store!.setHolderData({
                surname: surname
            })
            this.setState({
                surnameError: false
            })
        } else {
            this.setState({
                surnameError: true
            })
        }
    }

    setEmail = (event: any) => {
        const email: string = event.target.value

        if (email.length > 1 && email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
            this.props.store!.setHolderData({
                email: email
            })
            this.setState({
                emailError: false
            })
        } else {
            this.setState({
                emailError: true
            })
        }
    }

    setPhone = (event: any) => {
        const phone: string = event.target.value

        this.props.store!.setHolderData({
            phone: phone
        })
    }

    setCountry = (event: any, country: CountryType | null) => {
        if (country != null) {
            this.props.store!.setHolderData({
                country: country.label
            })
        }
    }

    setAgree = () => {
        this.props.store!.setHolderData({
            agree: !this.props.store!.holderData.agree
        })
    }

    render () {
        return (
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TextField
                        id="holderName"
                        fullWidth
                        label={this.props.t("Name")}
                        required
                        onChange={this.setName}
                        error={this.state.nameError}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        id="holderSurname"
                        fullWidth
                        label={this.props.t("Surname")}
                        required
                        onChange={this.setSurname}
                        error={this.state.surnameError}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        id="holderEmail"
                        fullWidth
                        label={this.props.t("Email")}
                        type="email"
                        required
                        onChange={this.setEmail}
                        error={this.state.emailError}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        id="holderPhone"
                        fullWidth
                        label={this.props.t("Phone")}
                        type="tel"
                        onChange={this.setPhone}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Autocomplete
                        id="holderCountry"
                        fullWidth
                        options={countries as CountryType[]}
                        getOptionLabel= {(option: CountryType) => option.label}
                        onChange={this.setCountry}
                        renderInput={params => (
                            <TextField
                                {...params}
                                label={this.props.t("Choose a country")}
                                InputLabelProps={{
                                    shrink: true
                                }}
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                id="holderAgree"
                                checked={this.props.store!.holderData.agree}
                                onChange={this.setAgree}
                                color="primary"
                            />
                        }
                        label={this.props.t("I agree with terms of use")}
                    />
                </Grid>
            </Grid>
        )
    }
}

export default withTranslation()(HolderForm)
